import {
  GetEventsResponse,
  ResolveAlertEvent,
} from "../../../api/appNotifications/appNotificationInterfaces";
import {
  DownloadNotification,
  Notification,
} from "../../../components/Layout/components/Header/components/Notifications/hooks/useNotifications/useNotifications";

export enum AppNotificationContextActionKind {
  SET_ALERTS_AND_NOTIFICATIONS_FROM_DOMAIN = "SET_ALERTS_AND_NOTIFICATIONS_FROM_DOMAIN",
  SET_ALERT_AND_NOTIFICATION_FROM_APPSYNC = "SET_ALERT_AND_NOTIFICATION_FROM_APPSYNC",
  SET_DOWNLOAD_NOTIFICATIONS = "SET_DOWNLOAD_NOTIFICATIONS",
  SET_EVENTS_LOADED = "SET_EVENTS_LOADED",
  TOGGLE_NOTIFICATION_SUMMARY_VISIBILITY = "TOGGLE_NOTIFICATION_SUMMARY_VISIBILITY",
  SET_IS_REAL_TIME_UPDATES_DOWN = "SET_IS_REAL_TIME_UPDATES_DOWN",
  MARK_EVENTS_FROM_DOMAIN_AS_READ = "MARK_EVENTS_FROM_DOMAIN_AS_READ",
  SET_BROADCAST_TOGGLE = "SET_BROADCAST_TOGGLE",
}

type SetAlertsAndNotificationsFromDomainAction = {
  type: AppNotificationContextActionKind.SET_ALERTS_AND_NOTIFICATIONS_FROM_DOMAIN;
  payload: GetEventsResponse[];
};

type SetAlertsAndNotificationsFromAppSyncAction = {
  type: AppNotificationContextActionKind.SET_ALERT_AND_NOTIFICATION_FROM_APPSYNC;
  payload: GetEventsResponse | ResolveAlertEvent;
};

type SetDownloadNotificationsAction = {
  type: AppNotificationContextActionKind.SET_DOWNLOAD_NOTIFICATIONS;
  payload: Notification<DownloadNotification>[];
};

type SetEventsLoadedAction = {
  type: AppNotificationContextActionKind.SET_EVENTS_LOADED;
  payload: boolean;
};

type SetToggleSummaryVisibilityAction = {
  type: AppNotificationContextActionKind.TOGGLE_NOTIFICATION_SUMMARY_VISIBILITY;
  payload: string;
};

type SetIsRealTimeUpdatesDownAction = {
  type: AppNotificationContextActionKind.SET_IS_REAL_TIME_UPDATES_DOWN;
  payload: boolean;
};

type MarkEventsFromDomainAsReadAction = {
  type: AppNotificationContextActionKind.MARK_EVENTS_FROM_DOMAIN_AS_READ;
  payload: string[];
};

type SetBroadcastToggleAction = {
  type: AppNotificationContextActionKind.SET_BROADCAST_TOGGLE;
  payload: boolean;
};

export type AppNotificationContextAction =
  | SetAlertsAndNotificationsFromDomainAction
  | SetAlertsAndNotificationsFromAppSyncAction
  | SetToggleSummaryVisibilityAction
  | SetDownloadNotificationsAction
  | SetEventsLoadedAction
  | SetIsRealTimeUpdatesDownAction
  | MarkEventsFromDomainAsReadAction
  | SetBroadcastToggleAction;

export function setAlertsAndNotificationsFromDomainAction(
  appNotificationsResponse: GetEventsResponse[]
): SetAlertsAndNotificationsFromDomainAction {
  return {
    type: AppNotificationContextActionKind.SET_ALERTS_AND_NOTIFICATIONS_FROM_DOMAIN,
    payload: appNotificationsResponse,
  };
}

export function eventFromAppSyncAction(
  appNotification: GetEventsResponse | ResolveAlertEvent
): SetAlertsAndNotificationsFromAppSyncAction {
  return {
    type: AppNotificationContextActionKind.SET_ALERT_AND_NOTIFICATION_FROM_APPSYNC,
    payload: appNotification,
  };
}

export function setDownloadNotificationsAction(
  downloadNotifications: Notification<DownloadNotification>[]
): SetDownloadNotificationsAction {
  return {
    type: AppNotificationContextActionKind.SET_DOWNLOAD_NOTIFICATIONS,
    payload: downloadNotifications,
  };
}

export function setEventsLoadedAction(
  eventsLoaded: boolean
): SetEventsLoadedAction {
  return {
    type: AppNotificationContextActionKind.SET_EVENTS_LOADED,
    payload: eventsLoaded,
  };
}

export function toggleSummaryVisibilityAction(
  id: string
): SetToggleSummaryVisibilityAction {
  return {
    type: AppNotificationContextActionKind.TOGGLE_NOTIFICATION_SUMMARY_VISIBILITY,
    payload: id,
  };
}

export function setIsRealTimeUpdatesDownAction(
  isConnectionDown: boolean
): SetIsRealTimeUpdatesDownAction {
  return {
    type: AppNotificationContextActionKind.SET_IS_REAL_TIME_UPDATES_DOWN,
    payload: isConnectionDown,
  };
}

export function setMarkEventsFromDomainAsReadAction(
  uniqueIds: string[]
): MarkEventsFromDomainAsReadAction {
  return {
    type: AppNotificationContextActionKind.MARK_EVENTS_FROM_DOMAIN_AS_READ,
    payload: uniqueIds,
  };
}

export function setBroadcastToggleAction(
  enabled: boolean
): SetBroadcastToggleAction {
  return {
    type: AppNotificationContextActionKind.SET_BROADCAST_TOGGLE,
    payload: enabled,
  };
}
